import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createSelector } from '@reduxjs/toolkit';
import { useMobile } from '@ff-os/shared-react/hooks/useMobile';
import { PhotoPrintsPdpState } from '@ff-scene-plugins/photo-prints-redux/store';
import { selectCompatibleBorderOptions } from '../../../_redux-borders';
import { selectCompatiblePaperOptions } from '../../../_redux-papers';
import { selectSizeOptions } from '../../../_redux-sizes';
import { VariantOption } from '../../../VariantOption';
import { VariantRadioGroup } from '../../variant-radio-group/VariantRadioGroup';
import { ChangeVariantWindowStep } from '../ChangeVariantWindowStep';
import styles from '../ChangeVariantWindow.module.scss';

const _ChangeSizeStep = ({
    imageUrl, sizeOptions, onChange,
    sizeId, stepper,
    paperOptions, setShowPaperStep,
    borderOptions, setShowBorderStep,
    setPaperId, setBorderId
}: Props) => {

    const isMobile = useMobile();

    useEffect(() => {

        setShowPaperStep(paperOptions.length > 1);

        if (paperOptions.length === 1) {
            setPaperId(paperOptions[0].value);
        }
    }, [setShowPaperStep, paperOptions, setPaperId]);

    useEffect(() => {
        setShowBorderStep(borderOptions.length > 1);

        if (borderOptions.length === 1) {
            setBorderId(borderOptions[0].value);
        }
    }, [setShowBorderStep, borderOptions, setBorderId]);

    return (
        <ChangeVariantWindowStep imageUrl={imageUrl} className={styles.container} stepper={stepper}>
            <VariantRadioGroup selected={sizeId} options={sizeOptions} onChange={onChange} />
        </ChangeVariantWindowStep>
    );
};

type OwnProps = {
    stepper?: () => JSX.Element;
    imageUrl?: string;
    paperId: string | undefined;
    sizeId: string | undefined;
    onChange: (sizeId: string) => void;
    setShowPaperStep: (show: boolean) => void;
    setPaperId: (paperId: string) => void;
    setBorderId: (borderId: string) => void;
    setShowBorderStep: (show: boolean) => void;
};

type Props = OwnProps & {
    sizeOptions: VariantOption[];
    paperOptions: VariantOption[];
    borderOptions: VariantOption[];
};

const mapStateToProps = (state: PhotoPrintsPdpState, ownProps: OwnProps) => ({
    sizeOptions: selectSizesOptions(state, ownProps.paperId),
    paperOptions: selectCompatiblePaperOptions(state, ownProps.sizeId),
    borderOptions: selectCompatibleBorderOptions(state, ownProps.sizeId, ownProps.paperId)
});

export const ChangeSizeStep = connect(
    mapStateToProps
)(_ChangeSizeStep);

const selectSizesOptions = createSelector([
    selectSizeOptions
], options => {
    if (options.length > 4) {
        return options
            .filter(size => !size.isAccessory)
            .map(o => ({
                ...o,
                name: o.label ?? o.name,
                label: undefined
            }));
    } else {
        return options.filter(size => !size.isAccessory);
    }
});